<template>
    <div class="nav-wrap">
        <ul class="nav-list">
            <li class="nav-item" v-for="(item, idx) in navList" :class="{ cur: $route.meta.active === item.name }"
                :key="item.name + idx" @click="handleNavClick(item)">
                <!-- <template v-if="item.name == 'LivePage'">
                    <a href="" class="lk">
                        <p class="text">{{ item.text }}</p>
                        <span class="tip">{{ item.tipName }}</span>
                    </a>
                </template> -->
                <template>
                    <!-- <div @click="jumTo(item.navPath)"> -->
                    <!-- <router-link :to="{ path: item.navPath }"> -->
                    <a class="lk" @click="jumTo(item)">
                        <p class="text">{{ item.text }}</p>
                        <span class="tip">{{ item.tipName }}</span>
                    </a>
                    <!-- </router-link> -->
                    <!-- </div> -->
                </template>
            </li>
        </ul>
    </div>
</template>

<script>
    import store from "@/store"
    // import CurrentConferMixin from "@/mixin/CurrentConference"

    export default {
        name: "PublicNav",
        data() {
            return {
                navList: [
                    {
                        text: "注册/登录",
                        tipName: "LOGIN",
                        name: "Login",
                    },
                    {
                        text: "首页",
                        tipName: "HOME",
                        name: "HomePage",
                        navPath: "/",
                    },
                    {
                        text: "我的报名",
                        tipName: "MY REGISTRATION",
                        name: "RegistrationPage",
                        navPath: "/registration",
                    },
                    {
                        text: "会议信息",
                        tipName: "MEETING INFORMATION",
                        name: "MeetingPage",
                        navPath: "/meeting",
                    },
                    {
                        text: "论文投稿",
                        tipName: "SUBMISSION OF PAPERS",
                        name: "PapersPage",
                        navPath: "/papers",
                    },
                    {
                        text: "会议直播",
                        tipName: "LIVE STREAMING OF THE CONFERENCE",
                        name: "LivePage",
                    },
                ],
            };
        },
        computed: {
            isTokenValid() {
                return this.$store.getters["auth/isTokenValid"]
            }
        },
        mounted() {
            this.ifLogin();

        },
        watch: {
            isTokenValid: {
                handler(val) {
                    if (val) {
                        this.navList[0].text = "退出登录";
                        this.navList[0].tipName = "LOGIN OUT";
                    } else {
                        this.navList[0].text = "登录";
                        this.navList[0].tipName = "LOGIN";
                    }
                }
            }
        },
        // mixins: [CurrentConferMixin],
        methods: {
            ifLogin() {
                if (this.isTokenValid) {
                    this.navList[0].text = "退出登录";
                    this.navList[0].tipName = "LOGIN OUT";
                } else {
                    this.navList[0].text = "登录";
                    this.navList[0].tipName = "LOGIN";
                }
            },
            handleNavClick(item) {
                this.$emit("getNavName", item);
            },
            jumTo(item) {
                let token = store.getters["auth/token"] || null
                //我的报名，论文投稿
                if (item.name == "RegistrationPage" || item.name == "PapersPage") {
                    let authorized = token && token.checkValid()
                    if (authorized) {
                        if (item.navPath) {
                            if (this.$store.state.conference.currentConference.status) {
                                if (this.$store.state.conference.currentConference.status !== "发布") {
                                    this.$message("请点击首页，更新当前会议")
                                    return
                                }
                            }
                        }
                        this.$router.push({ path: item.navPath })
                    } else {
                        this.$message('请先登录');
                    }
                }
                //会议直播
                if (item.name == "LivePage") {
                    if (this.$store.state.conference.currentConference.status) {
                        if (this.$store.state.conference.currentConference.status !== "发布") {
                            this.$message("请点击首页，更新当前会议")
                            return
                        }
                    }
                    if (this.$store.state.conference.currentConference) {
                        if (this.$store.state.conference.currentConference.liveurl) {
                            window.open(this.$store.state.conference.currentConference.liveurl, "_blank");
                        } else {
                            this.$message("尚未开始直播")
                        }
                    }
                    return
                }
                //会议信息，首页
                if (item.name == "MeetingPage" || item.name == "HomePage" ) {
                    this.$router.push({ path: item.navPath })
                }

            }
        },
    };
</script>

<style lang="scss" scoped>
    .nav-wrap {
        height: 100%;
    }

    .nav-list {
        @include flex-start;
        align-content: flex-start;
        height: 100%;

        .nav-item {
            position: relative;
            display: table;
            width: 110px;
            height: 100%;

            &.cur,
            &:hover {
                background: $defaultColor;

                a {
                    color: #fff;
                }
            }

            a {
                display: block;
                width: 100%;
                height: 100%;
                padding: 30px 0 0 15px;
                text-decoration: none;
                box-sizing: border-box;
                color: $defaultColor;
            }

            .text {
                font-size: 16px;
                font-weight:bold;
            }

            .tip {
                position: absolute;
                width: 140px;
                font-size: 14px;
                line-height: 15px;
                -webkit-transform-origin-x: 0;
                -webkit-transform: scale(0.6);
                transform: scale(0.6);
            }
        }
    }
</style>